module.exports = __webpack_public_path__ + "img/country7.3418e3b6.jpg";